import responseService from "./ResponceService";
import supportService from "./SupportService";

class EntityService {
    async getAll(entityName){
        const request = await responseService.get(supportService.getUrlByEntityName(entityName))
        if (!request?.success){
            throw request?.message??"Не удалось получить ответ от сервера"
        }
        return request.result
    }

    async getAllActive(entityName){
        const request = await responseService.get(supportService.getUrlByEntityName(entityName)+"all/")
        if (!request?.success){
            throw request?.message??"Не удалось получить ответ от сервера"
        }
        return request.result
    }

    async delete(entityName, entityId){
        const request = await responseService.delete(supportService.getUrlByEntityName(entityName)+entityId)
        if (!request?.success){
            throw request?.message??"Не удалось получить ответ от сервера"
        }
    }

    async add(entityName, entityObject){
        console.log('!!!!!!!!!!!!!!!!!!!', entityName,supportService.getUrlByEntityName(entityName), entityObject )
        const request = await responseService.post(supportService.getUrlByEntityName(entityName), entityObject)
        console.log('!!!!!!!!!!!!!!!!!!! request', request)
        if (!request || !request.success){
            throw request?.message??"Не удалось получить ответ от сервера"
        }
        return request.result
    }

    async update(entityName, entityObject){
        const request = await responseService.put(supportService.getUrlByEntityName(entityName), entityObject)
        if (!request || !request.success){
            throw request?.message??"Не удалось получить ответ от сервера"
        }
        return request.result
    }

    getEmptyGame() {
        return {
            color: "#000",
            isActive: true
        };
    }

    getEmptyEntityFunc(entityName){
        switch(entityName){
            case "additional_task":
            case "task":
                return ()=>{
                    return {codeWords: [""], isActive: true, score: 1};
                }
            case "level":
                return  ()=> {
                    return {isActive: true, levelType:"levelTaskWordEntered",geoPosition:["",""], codeWords:[""]}
                }
            default:
                return  ()=> {
                    return {isActive: true}
                }
        }
    }
}

const gameService = new EntityService()
export default gameService